import { useState } from 'react';

const useScroll = (initialActiveIndex) => {
    const [activeIndex, setActiveIndex] = useState(initialActiveIndex);

    const executeScroll = (index) => {
        setActiveIndex(index);
        const element = document.getElementById(`div_to_scroll_${index}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return { activeIndex, executeScroll };
};

export default useScroll;
